import { type ActionEvent, Controller } from "@hotwired/stimulus"

import CarouselController from "@/controllers/carousel_controller"
import LoaderController from "@/controllers/loader_controller"
import SearchDateController from "@/controllers/search/search_date_controller"
import SearchGuestsController from "@/controllers/search/search_guests_controller"

import { saveNavigationTypeToStorage } from "@/helpers/ga4_helper"

export default class SearchFormController extends Controller {
  static outlets = ["carousel", "page-loader", "search-date", "search-guests"]
  declare readonly carouselOutlet: CarouselController
  declare readonly pageLoaderOutlet: LoaderController
  declare readonly searchDateOutlet: SearchDateController
  declare readonly searchGuestsOutlet: SearchGuestsController

  static targets = ["dateInput", "dateRadio", "experienceInput", "guestsInput"]
  declare readonly dateInputTarget: HTMLInputElement
  declare readonly dateRadioTargets: HTMLInputElement[]
  declare readonly experienceInputTarget: HTMLInputElement
  declare readonly guestsInputTarget: HTMLInputElement

  jumpToSelectedDate(): void {
    window.requestAnimationFrame(() => {
      this.carouselOutlet.jumpToIndex(this.selectedDateCarouselSlideIndex)
    })
  }

  onDateFocus(): void {
    this.searchDateOutlet.selectCalendarTab()
    this.jumpToSelectedDate()
  }

  submit(): void {
    saveNavigationTypeToStorage("search_box")
    this.pageLoaderOutlet.startWithId(this.identifier)
  }

  setGuestsSummary(): void {
    this.guestsInputTarget.value = this.searchGuestsOutlet.summaryText
  }

  toDateStep(): void {
    this.dateInputTarget.focus()
  }

  toGuestsStep({ params: { name } }: ActionEvent): void {
    this.experienceInputTarget.value = name
    this.guestsInputTarget.focus()
  }

  private get selectedDateCarouselSlideIndex(): number {
    return this.selectedDateRadio
      ? this.carouselOutlet.slideListItemTargets.findIndex((slide) =>
          slide.contains(this.selectedDateRadio as Node)
        )
      : 0
  }

  private get selectedDateRadio(): HTMLInputElement | undefined {
    return this.dateRadioTargets.find((radio) => radio.checked)
  }
}
